<template lang="pug">
	button.btn(type="button" @click="onClick" v-bind:class="btnClass")
		div
			slot
</template>

<script>
export default {
	name : 'ButtonThemed',
	props: {
		spaced: Boolean
	},
	computed: {
		btnClass () {
			return { 'is-spaced': this.spaced }
		}
	},
	methods: {
		onClick (ev) {
			this.$emit('click', ev)
		}
	}
}
</script>
